import { IMasterData, IMasterRole, IMdhRequest, IMdhUserRole } from "@/models";

interface IMdhState {
    masterDatas: IMasterData[];
    myRequests: IMdhRequest[];
    pendingRequests: IMdhRequest[];
    roles: IMasterRole[];
    userRoles: IMdhUserRole[];
    validatedRequests: IMdhRequest[];
}

const initialState: IMdhState = {
    masterDatas: [],
    myRequests: [],
    pendingRequests: [],
    roles: [],
    userRoles: [],
    validatedRequests: [],
};

export { IMdhState, initialState };
